import { render, staticRenderFns } from "./BrickBreakerGame.vue?vue&type=template&id=b9f3075c&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./BrickBreakerGame.vue?vue&type=style&index=0&id=b9f3075c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f3075c",
  null
  
)

export default component.exports